// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {alertService} from "../../../../services/AlertService";

import TableCard from "../../../../components/tablecard/TableCard";
import Loading from "../../../../components/loading/Loading";

import {cutiTransaksiSelector, getCutiTransaksiMandiri, InsertCutiSelf, updateCutiSelf,} from "./cutiTransaksiSlice";
import {getMinKaryawanCuti, karyawanSelector,} from "../../karyawan/karyawanSlice";
import {jabatanSelector} from "../../../master/jabatan/jabatanSlice";

import {bagianSelector} from "../../../master/bagian/bagianSlice";
import {Colors} from "../../../../assets/Colors";
import { tanggalLokal } from "./tanggalLokal";

function isRequired(value) {
    let status = false;
    if (value !== null) {
        if (typeof value === "number") {
            if (value !== -1) {
                status = true;
            }
        }

    }
    return status;
}

function isSame(value1, value2) {
    return value1 === value2;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {
}) {
    const {isValid: initialIsValid, errors: initialErrors} = validate(
        validations,
        initialState
    );
    const [changed, setChanged] = useState(false);
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [isValid, setValid] = useState(initialIsValid);
    const [touched, setTouched] = useState({});

    const changeHandler = (event) => {
        const newValues = {...values, [event.target.name]: event.target.value};
        const {isValid, errors} = validate(validations, newValues);
        setChanged(true);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
        setTouched({...touched, [event.target.name]: true});
    };

    const editHandler = (initValues) => {
        const newValues = {
            ...values,
            JenisCuti: initValues.JenisCuti,
            KeperluanCuti: initValues.KeperluanCuti,
            Pengganti: initValues.Pengganti,
            Tiket: initValues.Tiket,
        };
        setValues(newValues);
    };

    const clearHandler = () => {
        setValues(initialState);
    };

    const submitHandler = (event) => {
        event.preventDefault();
        onSubmit(values);
    };
    return {
        values,
        changeHandler,
        editHandler,
        clearHandler,
        isValid,
        errors,
        touched,
        submitHandler,
    };
}

function validate(validations, values) {
    const errors = validations
        .map((validation) => validation(values))
        .filter((validation) => typeof validation === "object");
    return {
        isValid: errors.length === 0,
        errors: errors.reduce((errors, error) => ({...errors, ...error}), {}),
    };
}

const CutiMandiri = ({}) => {
    let initialState = {
        JenisCuti: -1,
        KeperluanCuti: "",
        SisahCuti: "",
        Pengganti: "",
        Tiket: false,
    };

    const validations = [
        ({JenisCuti}) =>
            isRequired(JenisCuti) || {JenisCuti: "Jenis cuti wajib diisi"},
        ({KeperluanCuti}) =>
            isRequired(KeperluanCuti) || {
                KeperluanCuti: "Keperluan cuti wajib diisi",
            },
        ({Pengganti}) =>
            isRequired(Pengganti) || {Pengganti: "Pengganti wajib diisi"},
    ];

    const {
        changed,
        values,
        isValid,
        errors,
        touched,
        changeHandler,
        editHandler,
        clearHandler,
        submitHandler,
    } = useForm(initialState, validations);
    const [buttonTouched, setButtonTouched] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [TanggalMulai, setTanggalMulai] = useState("");
    const [TanggalAkhir, setTanggalAkhir] = useState("");
    const [isValidTanggalMulai, setIsValidTanggalMulai] = useState(true);
    const [isValidTanggalAkhir, setIsValidTanggalAkhir] = useState(true);
    const [dateChanged, setDateChanged] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);

    const [insertFetch, setInsertFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const cuti = useSelector(cutiTransaksiSelector);
    const karyawan = useSelector(karyawanSelector);
    const jabatan = useSelector(jabatanSelector);
    const bagian = useSelector(bagianSelector);

    useEffect(() => {
        dispatch(
            getCutiTransaksiMandiri({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (showModalEdit && !showModalAdd) {
            setShowModalAdd(showModalEdit);
            const initValues = {
                JenisCuti: currentData.JenisCuti,
                KeperluanCuti: currentData.KeperluanCuti,
                Pengganti: currentData.Pengganti,
                Tiket: currentData.Tiket,
            };
            editHandler(initValues);
            setTanggalMulai(new Date(currentData.TanggalMulai));
            setTanggalAkhir(new Date(currentData.TanggalAkhir));
        }
        if (search !== "" && cuti.isGetSuccess && !cuti.isGetFetching) {
            let calc = cuti?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = cuti.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && cuti.isGetSuccess && !cuti.isGetFetching) {
            let calc = cuti?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = cuti.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (cuti.isGetSuccess && maxPage === 0 && firstLoading === false) {
            let calc = cuti?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = cuti.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getCutiTransaksiMandiri({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (cuti.isGetSuccess) {
                alertService.success(cuti.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getCutiTransaksiMandiri({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (cuti.isUpdateSuccess) {
                alertService.success(cuti.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateCutiSelf({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetCuti(params) {
    //   return dispatch(getCutiTransaksiMandiri(params));
    // }

    function handleInsertCuti(param) {
        setInsertFetch(true);
        const params = {
            namaCuti: param.inputOneValue,
            provinsiID: param.dropdownProvinsiValue,
        };
        dispatch(InsertCutiSelf(params));
    }

    function handleUpdateCuti(param) {
        setUpdateFetch(true);

        const params = {
            provinsiID: param.dropdownProvinsiValue,
            namaCuti: param.inputOneValue,
            cutiID: currentData.CutiID,
            status: param.status,
        };
        dispatch(updateCutiSelf(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getCutiTransaksiMandiri(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getCutiTransaksiMandiri(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = cuti.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? cuti.count : newCount,
            search: search,
        };
        dispatch(getCutiTransaksiMandiri(params));

        setPage(1);
        setCount(newCount === "-1" ? cuti.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);

        dispatch(getMinKaryawanCuti({search: ""}));
    }

    let user = JSON.parse(localStorage.getItem("user"));

    let lamaCuti = 0;
    let statusLamaCuti = false;
    if (TanggalMulai !== "" && TanggalAkhir !== "") {
        lamaCuti = Math.round(
            (TanggalAkhir.getTime() - TanggalMulai.getTime()) / (1000 * 60 * 60 * 24)
        ) + 1;
        if (values.SisahCuti !== "" && lamaCuti > values.SisahCuti) {
        }
    }

    if (!firstLoading) {
        return <Loading/>;
    } else {
        return (
            <>
                <div className="md:ml-64">
                    <div
                        style={{background: Colors.primary}}
                        className="pt-14 pb-16 px-3 md:px-8 h-auto"
                    >
                        <div className="container mx-auto max-w-full">
                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                        </div>
                    </div>

                    <div className="px-3 md:px-8 h-auto -mt-32">
                        <div className="container mx-auto max-w-full">
                            <div className="grid grid-cols-1 px-4">
                                <TableCard
                                    SearchBar={true}
                                    primaryID="TCutiID"
                                    editEnabled={true}
                                    transaksi={true}
                                    handleSearch={handleSearch}
                                    searchPlaceholder="Cuti"
                                    updatePage={handleUpdatePage}
                                    updateCount={handleUpdateCount}
                                    currentData={handleCurrentData}
                                    currentPage={page}
                                    maxPage={maxPage}
                                    tableTitle="Master Cuti"
                                    tableData={cuti.data}
                                    colOneTitle="ID"
                                    colOneData="TCutiID"
                                    colTwoTitle="Nama Karyawan"
                                    colTwoData="NamaKaryawan"
                                    colThreeTitle="Keterangan"
                                    colThreeData="JenisCutiKet"
                                    colFiveTitle="Tanggal"
                                    colFiveData="TanggalMonitoring"
                                    colSevenTitle="Status Approval"
                                    colSevenData="StatusKet"
                                    // status="Status"
                                    fetching={cuti.isGetFetching}
                                    modal={handleModal}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    size="regular"
                    active={showModalAdd}
                    toggler={() => {
                        setShowModalAdd(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setTanggalMulai("");
                            setTanggalAkhir("");
                            setShowModalAdd(false);
                            setShowModalEdit(false);
                            setButtonTouched(false);
                            clearHandler();
                        }}
                    >
                        {showModalEdit ? "Edit Data" : "Tambah Data"}
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg" onSubmit={submitHandler}>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Sisa Cuti
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <select
                                            disabled
                                            value={user.Nik}
                                            onChange={changeHandler}
                                            name="Nik"
                                            // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                            className={
                                                "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                        >
                                            {values.Nik === "" && (
                                                <option defaultValue value=""></option>
                                            )}
                                            {karyawan.minDataCuti.map((item) => (
                                                <option key={item.Nik} value={item.Nik}>
                                                    {item.SisahCuti}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Cuti *
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <select
                                            value={values.JenisCuti}
                                            onChange={changeHandler}
                                            name="JenisCuti"
                                            // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                            className={
                                                (touched.JenisCuti || buttonTouched) && errors.JenisCuti
                                                    ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                        >
                                            <option defaultValue disabled value={-1} hidden>
                                                -- Pilih Data --
                                            </option>
                                            <option value={1}>Tahunan</option>
                                            <option value={2}>Hamil</option>
                                            <option value={3}>Cuti Khusus</option>
                                            <option value={4}>Cuti Bersama</option>
                                        </select>
                                        <div
                                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg
                                                className="fill-current h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                            </svg>
                                        </div>
                                        {(touched.JenisCuti || buttonTouched) &&
                                            errors.JenisCuti && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.JenisCuti}
                                                </p>
                                            )}
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Keperluan Cuti *
                                    </label>
                                    <input
                                        value={values.KeperluanCuti}
                                        onChange={changeHandler}
                                        name="KeperluanCuti"
                                        className={
                                            (touched.KeperluanCuti || buttonTouched) &&
                                            errors.KeperluanCuti
                                                ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                    />
                                    {(touched.KeperluanCuti || buttonTouched) &&
                                        errors.KeperluanCuti && (
                                            <p className="text-red-500 text-xs italic">
                                                {errors.KeperluanCuti}
                                            </p>
                                        )}
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Pengganti *
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <select
                                            disabled={values.Nik === ""}
                                            value={values.Pengganti}
                                            onChange={changeHandler}
                                            name="Pengganti"
                                            // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                            className={
                                                (touched.Nik || buttonTouched) && errors.Nik
                                                    ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                        >
                                            <option defaultValue disabled value="" hidden>
                                                -- Pilih Data --
                                            </option>
                                            {karyawan.minDataCuti.map((item) =>
                                                values.Nik === item.Nik ? (
                                                    <option hidden key={item.Nik} value={item.Nik}>
                                                        {item.NamaKaryawan}
                                                    </option>
                                                ) : (
                                                    <option key={item.Nik} value={item.Nik}>
                                                        {item.NamaKaryawan}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                        <div
                                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg
                                                className="fill-current h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                            </svg>
                                        </div>
                                        {(touched.Pengganti || buttonTouched) &&
                                            errors.Pengganti && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.Pengganti}
                                                </p>
                                            )}
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Mulai *
                                    </label>
                                    <DatePicker
                                        className={
                                            !isValidTanggalMulai
                                                ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        }
                                        selected={TanggalMulai}
                                        onChange={(date) => {
                                            setTanggalMulai(date);
                                            setTanggalAkhir("");
                                            setIsValidTanggalMulai(true);
                                            setIsValidTanggalAkhir(false);
                                            if (showModalEdit) {
                                                setDateChanged(true);
                                            }
                                        }}
                                    />
                                    {!isValidTanggalMulai && (
                                        <p className="text-red-500 text-xs italic">
                                            Tanggal mulai wajib diisi
                                        </p>
                                    )}
                                </div>

                                <div className="w-full md:w-1/2 px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Akhir *
                                    </label>
                                    <DatePicker
                                        className={
                                            !isValidTanggalAkhir
                                                ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        }
                                        disabled={TanggalMulai === ""}
                                        minDate={new Date(TanggalMulai).setDate(
                                            new Date(TanggalMulai).getDate()
                                        )}
                                        selected={TanggalAkhir}
                                        onChange={(date) => {
                                            setTanggalAkhir(date);
                                            setIsValidTanggalAkhir(true);
                                            if (showModalEdit) {
                                                setDateChanged(true);
                                            }
                                        }}
                                    />
                                    {!isValidTanggalAkhir && (
                                        <p className="text-red-500 text-xs italic">
                                            Tanggal akhir wajib diisi
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                {/* <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Lama Cuti
                  </label>
                  <div className="inline-block relative w-full  ">
                    <input
                      disabled
                      value={lamaCuti}
                      name="LamaCuti"
                      className={
                        statusLamaCuti
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="text"
                    />
                    {statusLamaCuti && (
                      <p className="text-red-500 text-xs italic">
                        Lama cuti melebihi sisa cuti
                      </p>
                    )}
                  </div>
                </div> */}
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tiket
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <select
                                            value={values.Tiket}
                                            onChange={changeHandler}
                                            name="Tiket"
                                            // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                            className={
                                                "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                        >
                                            <option value={false}>Tidak</option>
                                            <option value={true}>Iya</option>
                                        </select>
                                        <div
                                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg
                                                className="fill-current h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="red"
                            buttonType="link"
                            onClick={() => {
                                setTanggalMulai("");
                                setTanggalAkhir("");
                                setShowModalAdd(false);
                                setShowModalEdit(false);
                                clearHandler();
                            }}
                            ripple="dark"
                        >
                            Cancel
                        </Button>

                        <Button
                            color={
                                (isValid || (showModalEdit && dateChanged && !isValid)) &&
                                isValidTanggalMulai &&
                                isValidTanggalAkhir
                                    ? "green"
                                    : "blueGray"
                            }
                            onClick={() => {
                                if (!isValid && changed) {
                                    setButtonTouched(true);
                                }
                                if (TanggalMulai === "") {
                                    setIsValidTanggalMulai(false);
                                }
                                if (TanggalAkhir === "") {
                                    setIsValidTanggalAkhir(false);
                                }
                                let tempIsValid = isValid;
                                if (showModalEdit && dateChanged && !isValid) {
                                    tempIsValid = true;
                                }
                                if (tempIsValid && isValidTanggalMulai && isValidTanggalAkhir) {
                                    const tanggal = {
                                        TanggalMulai: tanggalLokal(TanggalMulai),
                                        TanggalAkhir: tanggalLokal(TanggalAkhir),
                                        TCutiID: currentData.TCutiID,
                                    };
                                    setShowModalAdd(false);
                                    setShowModalEdit(false);
                                    if (showModalEdit) {
                                        dispatch(updateCutiSelf(Object.assign(values, tanggal)));
                                    } else {
                                        dispatch(InsertCutiSelf(Object.assign(values, tanggal)));
                                    }
                                }
                            }}
                            ripple={
                                isValid && isValidTanggalMulai && isValidTanggalAkhir
                                    ? "light"
                                    : ""
                            }
                        >
                            SUBMIT
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
};

export default CutiMandiri;
